var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnonymiser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.688,
    height: 21.688,
    viewBox: "0 0 21.688 21.688",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.844,21.687A10.844,10.844,0,1,1,21.687,10.844,10.856,10.856,0,0,1,10.844,21.687ZM1.807,10.844a9.03,9.03,0,0,0,14.752,6.992L3.851,5.129A8.991,8.991,0,0,0,1.807,10.844Zm9.036-9.036A8.994,8.994,0,0,0,5.129,3.851L17.837,16.558A9.03,9.03,0,0,0,10.844,1.807Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnonymiser);
export default __webpack_public_path__ + "static/media/anonymiser.77440e048ade42575cf0bc2694be322d.svg";
export { ForwardRef as ReactComponent };